import { useEffect, useState } from 'react';

function LanguagesUpdate({ language, onUpdate, onCancel, submitting }) {
  const [form, setForm] = useState({ iso: '', name: '' });

  useEffect(() => {
    setForm({
      iso: language?.lng_iso || language?.iso || '',
      name: language?.lng_name || language?.name || ''
    });
  }, [language]);

  async function handleSubmit(event) {
    event.preventDefault();
    if (!language) return;
    await onUpdate(String(language.lng_id || language.id), {
      iso: form.iso.trim().toLowerCase(),
      name: form.name.trim()
    });
  }

  if (!language) return null;

  return (
    <div className="language-form-shell">
      <div className="language-form-intro">
        <p className="language-form-kicker">Edit Language</p>
        <h3>Update language details</h3>
        <p>
          Refine the ISO code or display name while keeping the record aligned
          with the rest of the CMS.
        </p>
      </div>

      <form className="language-form-grid" onSubmit={handleSubmit}>
        <label className="language-form-field">
          ISO
          <small>Keep it short and consistent with the language standard.</small>
          <input
            className="field-input"
            maxLength={10}
            value={form.iso}
            onChange={(e) => setForm((prev) => ({ ...prev, iso: e.target.value }))}
            required
          />
        </label>
        <label className="language-form-field">
          Name
          <small>Use the readable label shown across the CMS.</small>
          <input
            className="field-input"
            maxLength={120}
            value={form.name}
            onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
            required
          />
        </label>
        <div className="language-form-actions">
          <button className="button-primary" type="submit" disabled={submitting}>
            {submitting ? 'Saving...' : 'Update language'}
          </button>
          <button className="button-ghost" type="button" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default LanguagesUpdate;
